<div class="tab-inner-content">
  <h2>Journal Report</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <table>
    <ng-container *ngIf="journalReport?.length > 0; else noData">
      <ng-container *ngFor="let group of journalReport">
        <tr>
          <th>{{ group.date | date : "MM/d/YYYY" }} (ID: {{ group.journalNo }})</th>
          <th>Debit (In AED)</th>  
          <th>Credit (In AED)</th>
        </tr>
        <tr class="title">
          <td colspan="3">{{ group.reference }}</td>
        </tr>
        <ng-container *ngFor="let item of group.journalEntries">
          <tr class="child">
            <td>{{ item?.accountData?.accountName }}</td>
            <td>{{ item.debit | number : "1.2-2" }}</td>
            <td>{{ item.credit | number : "1.2-2" }}</td>
          </tr>
        </ng-container>
        <tr class="sub-total">
          <td>Total</td>
          <td>AED {{ getTotalDebit(group.journalEntries) | number : "1.2-2" }}</td>
          <td>AED {{ getTotalCredit(group.journalEntries) | number : "1.2-2" }}</td>
        </tr>
      </ng-container>
    </ng-container>
    <!-- Display this if journalReport is empty -->
    <ng-template #noData>
      <tr>
        <td colspan="3" class="no-data">
          There are no transactions during the selected date range
        </td>
      </tr>
    </ng-template>
  </table>
</div>
